import { Component, ViewChild, ElementRef, input, signal, computed, output } from "@angular/core";
import { environment } from "@environments/environment";

@Component({
  selector: "app-audio-stream",
  template: `
    <audio
      #audio
      data-testid="audio-input"
      preload="none"
      (play)="isPlaying.set(true)"
      (ended)="isPlaying.set(false)"
      (error)="onError($event)"
      (loadstart)="isLoading.set(true)"
      (canplay)="isLoading.set(false)"
    ></audio>

    <button
      type="button"
      (click)="play()"
      [disabled]="disabled() || isLoading()"
      class="play-button"
      aria-label="Jouer l'extrait audio"
      aria-controls="audio"
    >
      <img src="assets/icons/speaker.svg" />
    </button>
  `,
  styles: [
    `
      @use "visuallyhidden" as *;

      .play-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        padding: 0;
        border: none;
        border-radius: 15px;
        background-color: #51b6c2;

        &:focus {
          outline: none;
          box-shadow: 0 0 0 4px #2e7b84;
        }

        &:not(:disabled):hover {
          background-color: #7bc8d1;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }

      audio {
        @include visuallyhidden();
      }
    `,
  ],
})
export class AudioStreamComponent {
  @ViewChild("audio") audioElement!: ElementRef<HTMLAudioElement>;

  audioFileName = input.required<string>();
  disabled = input<boolean>();
  class = input<string>("");

  playAudio = output<void>();

  audioUrl = computed(() => `${environment.audioFile.storageUrl}/${this.audioFileName()}`);
  isPlaying = signal(false);
  isLoading = signal(false);

  async play() {
    const audio = this.audioElement.nativeElement;

    try {
      if (audio.src !== this.audioUrl()) {
        audio.src = this.audioUrl();
      }

      await audio.play();
      this.playAudio.emit();
    } catch (error) {
      console.error("Playback failed:", error);
    }
  }

  onError(event: Event) {
    console.error("Audio error:", {
      audioFileName: this.audioFileName(),
      audioUrl: this.audioUrl(),
      event,
    });
    this.isLoading.set(false);
  }
}
